import { Injectable } from "@nestjs/common";
import { CommonResponseModel, VendorStatusReq } from "@project-management-system/shared-models";
import { VendorsEntity } from "./entity/vendors.entity";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { promises } from "dns";

@Injectable()
export class VendorRegService {
    constructor(
        @InjectRepository(VendorsEntity)
        private vendorRepo: Repository<VendorsEntity>,
    ) { }

    async createVendor(req: any): Promise<CommonResponseModel> {
        console.log(req)
        const entObj = new VendorsEntity()
        entObj.vendorName = req.vendorName
        entObj.phoneNumber = req.phoneNumber
        entObj.email = req.email
        entObj.contactPerson = req.contactPerson
        entObj.address = req.address
        const save = await this.vendorRepo.save(entObj)
        if (save) return new CommonResponseModel(true, 1, 'Vendors Saved Successfully')
        return new CommonResponseModel(false, 0, 'Something went wrong while saving')
    }

    async getVendorsData(): Promise<CommonResponseModel> {
        const data = await this.vendorRepo.find()
        if (data.length) return new CommonResponseModel(true, 1, 'Data Retrivesd', data)
        return new CommonResponseModel(false, 0, 'No data')
    }

    async updateRejectStatus(req: VendorStatusReq): Promise<CommonResponseModel> {

        const update = await this.vendorRepo.update({ id: req.id }, { status: req.status, })
        console.log(update, '----update')
        if (update.affected) return new CommonResponseModel(true, 1, 'Status Updated Successfully')
        return new CommonResponseModel(false, 0, 'Something went wrong while updating')
    }

    async updateApproveStatus(req: VendorStatusReq): Promise<CommonResponseModel> {
        const update = await this.vendorRepo.update({ id: req.id }, { status: req.status })
        if (update.affected) return new CommonResponseModel(true, 1, 'Status Updated Successfully')
        return new CommonResponseModel(false, 0, 'Something went wrong while updating')
    }



}